import Teams from './Teams.container';

export default Teams;
